import { getCookieDomain } from '../utils/analytics'

const fbpRand = () => _random(1000000000, 9999999999)

const createFbp = () => `fb.1.${Date.now()}.${fbpRand()}`
const createFbc = (fbclid: string) => `fb.1.${Date.now()}.${fbclid}`

export default defineNuxtPlugin(() => {
  const _fbp = useCookie('_fbp', { domain: getCookieDomain() })
  _fbp.value = _fbp.value || createFbp()

  const route = useRoute()
  const fbclid = route.query.fbclid
  const _fbclid = useCookie('_fbclid', { domain: getCookieDomain() })

  if (!_isNil(fbclid) && fbclid !== _fbclid.value) {
    const _fbc = useCookie('_fbc', { domain: getCookieDomain() })
    _fbc.value = createFbc(fbclid)
    _fbclid.value = fbclid
  }
})
